module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgB7ZTZDYQwDEStrWBLoIQtYTtLOiAdUAp0QgmUYGJExHAnYL7IkyyEsWZschBl3gMzGx8dxyO1Zax4ydexC62/j0qemAydFxSJ1IZJ4L3GCbF4gBIBMQNNdis9BYOA8/F9wqDBf65ucJT/kAKnm0NpDcyunpKB0PK0fVUNilF8BhbePmhjzuI0tPMhFbdhLHq/ZUeO0y87S5lMD8/yQeDp6zOsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/vcwhticon.png
// module id = 1176
// module chunks = 0